<template>
    <div class="footer-container">
        <div class="d-flex">
            <div class="flex-grow-0 col-auto me-3">
                <BaseText text="Footer.customerService" class="bold mb-0 white"></BaseText>
                <BaseText text="Footer.adress" class="mb-0"></BaseText>
                <BaseText text="Footer.municipality" class="mb-0"></BaseText>
            </div>
            <div class="flex-shrink-0">
                <p>{{ "Tlf. " }}<a href="tel:+4570210230" class="text-reset">
                        {{ "70 210 230" }}
                    </a>
                </p>
                <BaseText text="Footer.contact" class="mb-0" url="contactUsUrl" linkText="Footer.contact"
                    replacement="Footer.contact"></BaseText>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import BaseText from '@/components/base/BaseText.vue';

</script>

<style scoped lang="scss">
@import '@/styles/components/mainFooter';
</style>
